import React, { HTMLAttributeAnchorTarget, HTMLAttributes, ReactNode, forwardRef } from 'react';

interface AnchorLinkProps extends HTMLAttributes<HTMLAnchorElement> {
  to: string;
  target?: HTMLAttributeAnchorTarget;
  children: ReactNode;
}

const AnchorLink = forwardRef<HTMLAnchorElement, AnchorLinkProps>(
  ({ to, target = '_blank', children, ...props }, ref) => {
    return (
      <a ref={ref} href={to} target={target} {...props}>
        {children}
      </a>
    );
  },
);

export default AnchorLink;
